/**
 * Sign-in route (simplified from web/src/routes/SignInRoute.tsx).
 *
 * Uses Clerk's hosted <SignIn /> component mounted on the /sign-in path (same
 * Clerk instance as the customer dashboard). The return path is preserved
 * through the auth flow and validated on success.
 */
import { SignIn, useAuth } from '@clerk/clerk-react';
import { Navigate, useLocation } from 'react-router-dom';
import { parseReturnIntent } from '@/auth/returnPath';
import { AuthCard } from '@/components/navigation/AuthCard';
import { BrandMark } from '@/components/navigation/BrandMark';

export function SignInRoute() {
  const { isLoaded, isSignedIn } = useAuth();
  const location = useLocation();
  const intent = parseReturnIntent(location.search);

  if (!isLoaded) return null;
  if (isSignedIn) return <Navigate to={intent.returnPath ?? '/'} replace />;

  return (
    <AuthCard>
      <div className="mb-6 flex justify-center">
        <BrandMark />
      </div>
      <SignIn
        routing="path"
        path="/sign-in"
        fallbackRedirectUrl={intent.returnPath ?? '/'}
        appearance={{
          elements: { card: 'shadow-none p-0' },
        }}
      />
    </AuthCard>
  );
}
